import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';

import ModalLoad from '../modal/ModalLoad.js';
import ModalPopupMessage from '../modal/ModalPopupMessage.js';

function HistoricalDataENSValidation(props) {
    const [ensdata, setENSData] = useState({
        tabledata: [],
        has_irr2: false,
        total_meter: 1,
        records_count: 0,
        table_header: '-'
    });

    const [reportsite, setReportsite] = useState('-');

    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setENSData({
                tabledata: [],
                has_irr2: false,
                total_meter: 1,
                records_count: 0,
                table_header: '-'
            })
        };
    }, []);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.has_irr2 !== undefined && props.data_uioption.has_irr2 !== null) {
                setENSData({
                    ...ensdata,
                    has_irr2: props.data_uioption.has_irr2,
                    total_meter: props.data_uioption.total_meter,
                })
            }
        }
    }, [props.data_uioption]);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
    }

    async function api_query() {
        let dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD")

        setmodal_load({ enable: true, message: "Query historical ens track." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportdate', dt)
        if (props.permitdata.view_mode === "local") {
            formData.append('reportsite', props.permitdata.sitecode)
        } else {
            formData.append('reportsite', reportsite)
        }

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/ensvalidation", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.tabledata !== null) {
                        setENSData({
                            ...ensdata,
                            tabledata: response.data.tabledata,
                            has_irr2: response.data.has_irr2,
                            total_meter: response.data.total_meter,
                            records_count: response.data.records_count,
                            table_header: response.data.table_header
                        })
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        // if (chart_plot.CSV_Data.length > 0) {
        //     let tableheader = ['Timestamp',
        //         'Irradiation #1 (W/m2)']

        //     if (chart_plot.CSV_Data[0]["irr2"] !== undefined) {
        //         tableheader.push('Irradiation #2 (W/m2)')
        //     }
        //     tableheader.push('Ambient Temperature (°C)')
        //     tableheader.push('Relative Humidity (%RH)')
        //     tableheader.push('Panel Temperature (°C)')
        //     tableheader.push('Tray Temperature (°C)')
        //     if (chart_plot.CSV_Data[0]["wind_speed"] !== undefined) {
        //         tableheader.push('Wind Speed (m/sec.)')
        //         tableheader.push('Wind Direction (Deg.)')
        //     }
        //     if (chart_plot.CSV_Data[0]["water_level"] !== undefined) {
        //         tableheader.push('Water Level (m.)')
        //     }

        //     const tableData = [];
        //     tableData.push(tableheader.join(","));
        //     for (const row of chart_plot.CSV_Data) {
        //         const rowData = [];
        //         if (row["timestamp"] !== null) {
        //             if (row["timestamp"] !== "-") {
        //                 if (row["timestamp"] !== null) {
        //                     rowData.push(row["timestamp"].replaceAll(",", ""))
        //                 } else { rowData.push('') }

        //                 if (row["irr1"] !== null) {
        //                     rowData.push(row["irr1"])
        //                 } else { rowData.push('') }
        //                 if (chart_plot.CSV_Data[0]["irr2"] !== undefined) {
        //                     if (row["irr2"] !== null) {
        //                         rowData.push(row["irr2"])
        //                     } else { rowData.push('') }
        //                 }

        //                 if (row["temp_ambient"] !== null) {
        //                     rowData.push(row["temp_ambient"])
        //                 } else { rowData.push('') }
        //                 if (row["humidity"] !== null) {
        //                     rowData.push(row["humidity"])
        //                 } else { rowData.push('') }
        //                 if (row["temp_pv"] !== null) {
        //                     rowData.push(row["temp_pv"])
        //                 } else { rowData.push('') }
        //                 if (row["temp_raceway"] !== null) {
        //                     rowData.push(row["temp_raceway"])
        //                 } else { rowData.push('') }

        //                 if (chart_plot.CSV_Data[0]["wind_speed"] !== undefined) {
        //                     if (row["wind_speed"] !== null) {
        //                         rowData.push(row["wind_speed"])
        //                     } else { rowData.push('') }
        //                     if (row["wind_direct"] !== null) {
        //                         rowData.push(row["wind_direct"])
        //                     } else { rowData.push('') }
        //                 }

        //                 if (chart_plot.CSV_Data[0]["water_level"] !== undefined) {
        //                     if (row["water_level"] !== null) {
        //                         rowData.push(row["water_level"])
        //                     } else { rowData.push('') }
        //                 }
        //                 tableData.push(rowData.join(","));
        //             }
        //         }
        //     }

        //     let data = tableData.join("\n");
        //     const a = document.createElement("a");
        //     a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
        //     var fnamey = 'EnvironmentSensor_' + chart_plot.FileName + '.csv'
        //     a.setAttribute("download", fnamey);
        //     document.body.appendChild(a);
        //     a.click();
        //     document.body.removeChild(a);
        // } else {
        //     setModal_popup({
        //         modaltype: 'modal-warning',
        //         headers: 'Warning',
        //         message: "No data to be export",
        //         enable: true
        //     })
        // }
    }

    function get_ens_color(data) {
        if (data.status_has_ens === undefined) {
            return "ens-status"
        }
        if (data.status_err_ens === true) {
            return "ens-status red"
        }
        if (data.status_has_ens === true) {
            return "ens-status yellow"
        }
        if (data.meter_5m_solar > 0) {
            return "ens-status green"
        }
        return "ens-status"
    }

    function toggle_display(data) {
        const nextdata = ensdata.tabledata.map(item => {
            if (item.group === data.group) {
                if (item.display === true) {
                    return {
                        ...item,
                        display: false,
                    };
                } else {
                    return {
                        ...item,
                        display: true,
                    };
                }
            } else {
                return item;
            }
        });
        setENSData({
            ...ensdata,
            tabledata: nextdata,
        })
    }

    function get_etheo_text(data) {
        if (data.status_has_ens === undefined) {
            return ""
        }
        if (data.status_has_ens === true && data.status_err_ens === true) {
            return "ERROR"
        }
        return data.etheo
    }

    function get_ens_text(data) {
        if (data.status_has_ens === undefined) {
            return ""
        }
        if (data.status_has_ens === true && data.status_err_ens === true) {
            return "ERROR"
        }
        return data.ens
    }

    function get_irr_sampling_color(data, tag) {
        if (data[tag] === "ERROR" || data[tag] === "DV-OFFLINE" || data[tag] === "LG-OFFLINE") {
            return "alarming-noblink-text"
        }
    }

    function get_thousang_tag(data) {
        if (data != undefined) {
            return data.toLocaleString('en-US')
        }
    }
    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> ENS Validation</h4>
                                    <p className="mb-0">Validate your daily energy not supply</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block " style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            {/* <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-1">Query Result - {ensdata.table_header}</h5>
                                    <h6 className="card-title font-weight-bold mb-2">Records Count : {ensdata.records_count}</h6>
                                    <div className="table-wrapper">
                                        <table className='table-ens-validation font-sarabun'>
                                            <thead>
                                                <tr>
                                                    <th rowSpan={3}>#</th>
                                                    <th rowSpan={3}>Timestamp</th>
                                                    <th colSpan={ensdata.has_irr2 === true ? 3 : 1}>Irradiation Record</th>
                                                    <th colSpan={ensdata.total_meter}>Solar Meter Record</th>
                                                    <th colSpan={5}>Calculation</th>
                                                </tr>
                                                <tr>
                                                    <th>Irradiation #1</th>
                                                    {ensdata.has_irr2 === true ? <th>Irradiation #2</th> : null}
                                                    {ensdata.has_irr2 === true ? <th>Average</th> : null}
                                                    <th>Solar Meter #1</th>
                                                    {ensdata.total_meter > 1 ? <th>Solar Meter #2</th> : null}
                                                    {ensdata.total_meter > 2 ? <th>Solar Meter #3</th> : null}
                                                    <th>IRR Hi</th>
                                                    <th>Solar Energy</th>
                                                    <th>PR 30 Days</th>
                                                    <th>E<sub>Theoretical</sub> </th>
                                                    <th>ENS Result</th>
                                                </tr>
                                                <tr>
                                                    <th>W/m<sup>2</sup></th>
                                                    {ensdata.has_irr2 === true ? <th>W/m<sup>2</sup></th> : null}
                                                    {ensdata.has_irr2 === true ? <th>W/m<sup>2</sup></th> : null}
                                                    <th>kWh</th>
                                                    {ensdata.total_meter > 1 ? <th>kWh</th> : null}
                                                    {ensdata.total_meter > 2 ? <th>kWh</th> : null}
                                                    <th>Wh/m<sup>2</sup></th>
                                                    <th>kWh</th>
                                                    <th>%</th>
                                                    <th>kWh</th>
                                                    <th>kWh</th>
                                                </tr>
                                            </thead>
                                            <tbody className='font-sarabun'>
                                                {
                                                    ensdata.tabledata.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={"D" + index} className={'' + (data.group === -1 || data.display === true ? "" : "d-none")}>
                                                                <td className='font-sarabun' align="left">{data.group != -1 ? data.group + 1 : "-"}</td>
                                                                <td className='font-sarabun' align="left">{data.timestamp}</td>
                                                                <td className={'font-sarabun ' + get_irr_sampling_color(data, 'irr1')} align="right">{data.irr1}</td>
                                                                {ensdata.has_irr2 === true ? <td className={'font-sarabun ' + get_irr_sampling_color(data, 'irr2')} align="right">{data.irr2}</td> : null}
                                                                {ensdata.has_irr2 === true ? <td className='font-sarabun' align="right"></td> : null}
                                                                <td className={'font-sarabun ' + (data.status_solar1 === false ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.meter_acc_solar1)}</td>
                                                                {ensdata.total_meter > 1 ? <td className={'font-sarabun ' + (data.status_solar2 === false ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.meter_acc_solar2)}</td> : null}
                                                                {ensdata.total_meter > 2 ? <td className={'font-sarabun ' + (data.status_solar3 === false ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.meter_acc_solar3)}</td> : null}
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className=''></td>
                                                            </tr>
                                                            {
                                                                data.is_break === true && index > 0 ?
                                                                    <tr key={"S" + index} className='row-sum cursor-pointers' onClick={() => { toggle_display(data) }}>
                                                                        <td className='font-sarabun' align="left"><div className={get_ens_color(data)}></div> {data.group + 1}</td>
                                                                        <td className='font-sarabun ' align="left">{data.timestamp}</td>
                                                                        <td className={'font-sarabun ' + (data.irr1_perr === true ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.irr1_avg)}</td>
                                                                        {ensdata.has_irr2 === true ? <td className={'font-sarabun ' + (data.irr2_perr === true ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.irr2_avg)}</td> : null}
                                                                        {ensdata.has_irr2 === true ? <td className={'font-sarabun ' + (data.status_err_ens_irr === true ? "alarming-noblink-text" : "")} align="right">{get_thousang_tag(data.irr_calc)}</td> : null}
                                                                        <td className={'font-sarabun ' + (data.status_solar1 === false ? "alarming-noblink-text" : "")} align="right">{data.meter_5m_solar1}</td>
                                                                        {ensdata.total_meter > 1 ? <td className={'font-sarabun ' + (data.status_solar2 === false ? "alarming-noblink-text" : "")} align="right">{data.meter_5m_solar2}</td> : null}
                                                                        {ensdata.total_meter > 2 ? <td className={'font-sarabun ' + (data.status_solar3 === false ? "alarming-noblink-text" : "")} align="right">{data.meter_5m_solar3}</td> : null}
                                                                        <td className={'font-sarabun ' + (data.status_err_ens_irr === true ? "alarming-noblink-text" : "")} align="right">{data.irr_hi}</td>
                                                                        <td className={'font-sarabun ' + (data.status_err_ens_solar === true ? "alarming-noblink-text" : "")} align="right">{data.meter_5m_solar}</td>
                                                                        <td className='font-sarabun ' align="right">{data.pr30d}</td>
                                                                        <td className={'font-sarabun ' + (data.status_err_ens === true ? "alarming-noblink-text" : "")} align="right">{get_etheo_text(data)}</td>
                                                                        <td className={'font-sarabun ' + (data.status_err_ens === true ? "alarming-noblink-text" : "")} align="right">{get_ens_text(data)}</td>
                                                                    </tr>
                                                                    :
                                                                    null
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
             {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataENSValidation